import { useLocation } from "react-router-dom";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { STATIC_ROUTES } from "../../scripts/routes.mjs";
import { staticCrumbName } from "../../scripts/page-schemas.mjs";

/**
 * The "Home > page" row of a flat route that has no breadcrumb of its own
 * (About, Shipping, FAQ, the Journal index …). Those pages carry the
 * BreadcrumbList JSON-LD of StaticRouteJsonLd, which described a row the page
 * did not show. The label is the one that block names, from the same route
 * table, so the row and the block cannot drift.
 */
export const StaticRouteBreadcrumbs = () => {
  const path = useLocation().pathname.replace(/\/+$/, "") || "/";
  const route = (STATIC_ROUTES as { path: string; title: string }[]).find((r) => r.path === path);
  return route ? <Breadcrumbs items={[{ label: staticCrumbName(route) }]} /> : null;
};
